import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const AlertIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 56 56"
			fill="none"
			className={props.className}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<rect x="4" y="4" width="48" height="48" rx="24" fill="#FEF0C7" />
			<path
				d="M28 24V28M28 32H28.01M26.29 18.86L17.82 33C17.65 33.3 17.55 33.65 17.55 33.99C17.55 34.34 17.64 34.69 17.81 34.99C17.99 35.29 18.24 35.55 18.54 35.72C18.84 35.9 19.18 36 19.53 36H36.47C36.82 36 37.16 35.9 37.46 35.72C37.76 35.55 38.01 35.29 38.19 34.99C38.36 34.69 38.45 34.34 38.45 33.99C38.45 33.65 38.35 33.3 38.18 33L29.71 18.86C29.53 18.57 29.28 18.32 28.98 18.15C28.68 17.99 28.34 17.9 28 17.9C27.66 17.9 27.32 17.99 27.02 18.15C26.72 18.32 26.47 18.57 26.29 18.86Z"
				stroke="#DC6803"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect x="4" y="4" width="48" height="48" rx="24" stroke="#FFFAEB" strokeWidth="8" />
		</svg>
	)
}

export default AlertIcon
